// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
    .card {
        box-shadow: none;
        margin-bottom: 0px;
    }
  }

.vscroll-viewport {
  height: 70vh;
  overflow-y: auto;
}

/* Keep the body table columns aligned with the sticky header table */
.vscroll-viewport table {
  table-layout: fixed;
  width: 100%;
}

.vscroll-viewport table td,
.vscroll-viewport table th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
